import { UiCardViewModel } from '@black/ui';
import { LiveClassResponseDTO } from '../core/state/live-class/models/live-class';
import { CourseItem } from '../core/state/course/models';
import { FormatterService } from './formatter.service';

type LiveClassCardOptions = {
  isEnrolled?: boolean;
  showButtons?: boolean;
  submitButtonText?: string;
};

type CourseCardOptions = {
  isEnrolled?: boolean;
  showButtons?: boolean;
  submitButtonText?: string;
};

export function toLiveClassCardViewModel(
  item: LiveClassResponseDTO,
  formatter: FormatterService,
  options?: LiveClassCardOptions
): UiCardViewModel {
  return {
    id: item.id ?? '',
    courseTitle: item.title,
    subject: item.subject,
    imageBannerSource: formatter.getResourceImagePath(
      item.settings.bannerImageResource
    ),
    description: item.details.descriptionSummary,
    totalMeetings: item.meetings.length,
    price: item.settings.price,
    medium: item.details.medium,
    startDate: item.details.startDate,
    duration: formatter.formatDuration(item.settings.maxDuration),
    level: item.targetAudience,
    sessions: item.meetings,
    isEnrolled: options?.isEnrolled,
    showButtons: options?.showButtons,
    submitButtonText: options?.submitButtonText,
  };
}

export function toCourseCardViewModel(
  item: CourseItem,
  formatter: FormatterService,
  options?: CourseCardOptions
): UiCardViewModel {
  return {
    id: item._id,
    courseTitle: item.title,
    subject: item.subject || formatter.getCategoryName(item.category) || 'General',
    imageBannerSource: formatter.getResourceImagePath(
      item.settings?.bannerImageResource
    ),
    description: item.details?.descriptionSummary || item.details?.description || '',
    isEnrolled: options?.isEnrolled,
    showButtons: options?.showButtons,
    submitButtonText: options?.submitButtonText,
  };
}